import React, {useEffect, useState} from "react";
import {
  CONNETTORI_OUTPUT_STRUCTURE,
  CONNETTORI_VERTICALI_OUTPUT_SCHEME,
  CONNETTORI_LEGNO_OUTPUT_SCHEME,
} from "@feature/services/connettori";
import SearchSelect from "@ui-components/SearchSelect";
import {buildOutputStructureOptions} from "@feature/services/connettori/lib/utils";

const COMPOSITE_OUTPUT_CALCULATION_TYPES = ["connector", "spreadsheet", "kcolor"];

const GroupHeading = ({children, ...props}) => (
  <p className="text-gray-400 font-medium text-xs mx-3 pointer-events-none" {...props}>
    {children}
  </p>
)

const ServiceConfiguratorCompositeOutputPathSelector = ({
  label,
  selectedOutputId,
  outputs,
  onChange,
  value,
  editable
}) => {

  // state
  const [options, setOptions] = useState();
  const [selectedOptionFinder, setSelectedOptionFinder] = useState();

  useEffect(() => {

    const selected = outputs.find(({id}) => id === selectedOutputId);
    if (selected?.output_type !== "calculation") {
      setOptions(undefined);
      return;
    }

    const settings = selected.calculation?.length === 1 && selected.calculation[0].startsWith('{')
      ? JSON.parse(selected.calculation[0])
      : undefined;
    const type = settings?.original;
    const isEligible = COMPOSITE_OUTPUT_CALCULATION_TYPES.includes(type);
    
    if (!isEligible) {
      setOptions(undefined);
      return;
    }

    let options, optionFinder;
    switch (type) {
      case "connector":
        const connectorType = settings?.connector_type || "diaphragm";
        switch (connectorType) {
          case "diaphragm":
            options = buildOutputStructureOptions(CONNETTORI_OUTPUT_STRUCTURE);
            break;
          case "vertical":
            options = buildOutputStructureOptions(CONNETTORI_VERTICALI_OUTPUT_SCHEME);
            break;
          case "wood":
            options = buildOutputStructureOptions(CONNETTORI_LEGNO_OUTPUT_SCHEME);
            break;
          default:
            throw new Error(`Unhandled connector type '${connectorType}'`);
        }
        optionFinder = () => () => options?.reduce(
          (acc, elem) => {
            if (Array.isArray(elem.options)) {
              // CASE A: elem is a group
              const first = elem.options.find((o) => o.value === value);
              if (!!first)
                return first;
            }
            else if (elem.value === value) {
              // CASE B: elem is a single option
              return elem;
            }
            return acc;
          },
          undefined
        );
        break;
      case "spreadsheet":
        if (selected.calculation.length>0) {
          options = JSON.parse(selected.calculation[0])?.output_ranges.map((output_range) => ({
            label: output_range.key,
            value: output_range.key
          }));
          optionFinder = () => () => options?.find((o) => o.value === value);
          break;
        }else{
          throw new Error(`spreadsheet is missing calculation data  ! id: ${selected.id} title: ${selected.title}`);
        }
      case "kcolor":
        options = [
          {
            label: "price",
            value: "price"
          },
          {
            label: "resa",
            value: "resa"
          },
          {
            label: "package",
            value: "min_qty"
          }
        ]
        optionFinder = () => () => options?.find((o) => o.value === value);
        break;
      default:
        throw new Error(`Unhandled input type '${selected.input_type}'`);
    }
    setOptions(options);
    setSelectedOptionFinder(optionFinder);
  }, [selectedOutputId, outputs, value]);  // eslint-disable-line react-hooks/exhaustive-deps
  
  if (!options || !selectedOptionFinder)
    return null;

  return (
    <SearchSelect
      disabled={!editable}
      label={label}
      options={options}
      value={selectedOptionFinder()}
      onChange={({value}) => { onChange(value); }}
      isClearable={true}
      components={{GroupHeading}}
    />
  )
};

export default ServiceConfiguratorCompositeOutputPathSelector;
